<style lang="scss">
.el-menu--collapse {
  width: auto !important;
  min-width: 70px;

  .title_tip {
    display: none;
  }
}

.disblock {
  display: inline-block;
}

.site-tips {
  position: absolute;
  text-align: center;
  max-width: 400px;
  max-height: 400px;
  overflow: auto;
  background: rgba(0, 0, 0, .6);
  color: #fff;
  border-radius: 5px;
  padding: 10px;
  display: inline-block;
  font-size: 12px;
  z-index: 19999
}
.light-theme .el-menu-item, .light-theme .el-submenu__title {
  padding-left: 20px !important;
  padding-right: 30px !important;
  //font-weight: bold;
  //font-size: 16px;
  font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,\5fae\8f6f\96c5\9ed1,Arial,sans-serif;
  line-height: 3!important;
  //height: auto!important;
  display: flex;
  align-items: center;
}
</style>
<template>
  <div class="menu-wrapper">
    <template v-for="(item, index) in routes">
      <div :key="index"
        v-if="(!item.hidden && item.children) && (isSystemRole ? true : buttonPageObj[item.name]) || item.name == 'factorInfo' || whiteList.includes(item.name)">
        <div v-if="item.children.length == 0 && item.orderNum != -1" @click="jumpRouter(item)" :key="item.name">
          <el-menu-item :index="item.path"
            :class="{ 'submenu-title-noDropdown': !isNest, 'is-active': getHighClass(item.path) }">
            <i v-if="item.icon" class="iconfont" :class="'icon-' + item.icon"></i>
            <i v-else class="fa fa-chevron-circle-right"></i>
            <span class="ml10 title_tip disblock" slot="title" v-tip :data-txt="item.title" style="width: 133px;">{{item.title }}</span>
          </el-menu-item>
        </div>
        <el-submenu v-else-if="item.orderNum != -1" :index="item.path || item.name" :key="item.name">
          <template slot="title">
            <i v-if="item.icon" class="iconfont" :class="'icon-' + item.icon"></i>
            <i v-else class="fa fa-chevron-circle-right"></i>
            <span class="ml10 title_tip disblock" slot="title" v-tip :data-txt="item.title"
              style="width: 105px;overflow: hidden;">{{ item.title }}</span>
          </template>
          <template v-for="(child, index) in item.children">
            <div v-if="(isSystemRole || child.name == 'factorInfo') ? true : buttonPageObj[child.name]" :key="index">
              <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children.length > 0" :routes="[child]"
                :key="child.path"></sidebar-item>
              <div v-else-if="child.orderNum != -1" @click="jumpRouter(child)" :key="child.name">
                <el-menu-item :index="child.path" :class="{ 'is-active': getHighClass(child.path) }">
                  <span class="ml10 title_tip disblock" slot="title" v-tip :data-txt="child.title"
                    style="width: 133px;">{{ child.title }}</span>
                </el-menu-item>
              </div>
            </div>
          </template>
        </el-submenu>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import { openFloatDialog, flotWindowList } from '@/utils/common'
import { getSystemRole } from '@/utils/auth'
export default {
  name: "SidebarItem",
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSystemRole: getSystemRole(),//如果是系统角色，展示所有菜单，否则比对buttonPageObj中的信息
      whiteList: ['ds9', 'weighingMonitor', 'videoMonitor', 'projectMonitor', 'temperature', 'dataReport']	//specialCode 的路由加到白名单中
    }
  },
  computed: {
    ...mapGetters([
      'buttonPageObj'
    ])
  },
  directives: {
    'tip': {
      inserted(el, binding) {
        let $div;
        el.addEventListener('mouseover', e => {
          const curStyle = window.getComputedStyle(el, ''); // 获取当前元素的style
          const textSpan = document.createElement('span'); // 创建一个容器来记录文字的width
          // 设置新容器的字体样式，确保与当前需要隐藏的样式相同
          textSpan.style.fontSize = curStyle.fontSize;
          textSpan.style.fontWeight = curStyle.fontWeight;
          textSpan.style.fontFamily = curStyle.fontFamily;
          // 将容器插入body，如果不插入，offsetWidth为0
          document.body.appendChild(textSpan);
          // 设置新容器的文字
          textSpan.innerHTML = el.innerText;
          if (textSpan.offsetWidth >= el.offsetWidth) {
            let text = e.target.getAttribute('data-txt') || el.innerText,
              top = e.clientY - 40,
              left = e.target.offsetWidth / 3;
            $div = document.createElement('div');
            $div.setAttribute('class', 'site-tips');
            $div.setAttribute('style', 'top:' + top + 'px;left:' + left + 'px');
            $div.innerHTML = text;
            document.body.appendChild($div);
          }
          // 移除刚刚创建的记录文字的容器
          document.body.removeChild(textSpan);
        })
        el.addEventListener('mouseout', e => {
          if ($div) {
            try {
              document.body.removeChild($div);
            } catch (e) {
            }
          }
        })
      }
    }
  },
  methods: {
    // 针对监测因素的菜单添加高亮处理
    getHighClass(path) {
      let a = path.split('/')
      let newPath = a.slice(a.length-2,a.length).join('/')
      return this.$route.path.includes(newPath) && path.includes('factorInfo') ? 'is-active' : ''
    },
    jumpRouter(item) {
      if (flotWindowList.includes(item.name)) {
        openFloatDialog(
          item.name,
          item.title,
          {},
          1400,
          600
        )
      } else if (item.name == 'intelligentCrane') {
        window.open('http://ovmzb.ovm.cn')
      }  else if (item.name == 'lassoPerformance') {
        //拉吊索性能评估跳转
        let nonce = new Date().getTime() + '';
        let  jumpUrl = '&sysUrl=assessment/toIotIndex';
        this.$httpProj
            .get("/signSso/getSsoSign?phoneNumber=18629510459&nonce="+ nonce)
            .then((data) => {
              window.open('https://bim.bnerc.com/ssoBeam?sign='+encodeURIComponent(data.data) +'&nonce=' + nonce + jumpUrl);
            });
      } else {
        this.$router.push(item.path)
      }
    }
  }
};
</script>

